webpackJsonp([273],{

/***/ 1161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonPage_vue__ = __webpack_require__(2802);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7491f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonPage_vue__ = __webpack_require__(4653);
function injectStyle (ssrContext) {
  __webpack_require__(4647)
  __webpack_require__(4649)
  this["$style"] = __webpack_require__(4651)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e7491f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CommonPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7491f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CommonPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // 子组件注册到当前组件
  components: {},
  // 自定义指令
  directives: {
    focus: {
      // 指令的定义
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  // 混合对象,可以包含任意组件选项
  mixins: [],
  // 单向传递父组件数据 可使用 sync 修饰符来改变传值
  props: {
    // this allows using the `value` prop for a different purpose
    value: String,
    // use `checked` as the prop which take the place of `value`
    checked: {
      type: Number,
      default: 0
    }
  },
  // 实例的数据对象
  data: function data() {
    return {};
  },

  // 计算属性将被混入到 Vue 实例中。
  computed: {},
  // 检测数据变化
  watch: {
    value: function value(val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal);
    },
    // 深度 watcher, 可用来检测数组/对象变化
    array: {
      handler: function handler(val, oldVal) {/* ... */},
      deep: true
    }
  },
  created: function created() {/* 在实例创建完成后被调用 */},
  mounted: function mounted() {/* 在挂载到实例上去之后被调用 */},
  destroyed: function destroyed() {/* 实例销毁后调用 */},

  // 混入到 Vue 实例中, 能直接同步调用
  methods: {},
  // 自定义过滤器
  filters: {}
});

/***/ }),

/***/ 4647:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6be439c8", content, true, {});

/***/ }),

/***/ 4648:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CommonPage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4649:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4650);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("769a586c", content, true, {});

/***/ }),

/***/ 4650:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CommonPage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4651:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4652);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("555c17b4", content, true, {});

/***/ }),

/***/ 4652:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CommonPage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.name),expression:"$route.name"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.name)+"\n      "),_c('small',[_vm._v("一个用于描述的小标题")])]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("演示")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("空白页")])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("CommonPage")]),_vm._v(" "),_c('h1',[_vm._v("CommonPage")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-review-assessment-questionnaire-config.b35694ef71c5699a5ec8.js